import ProductSlider from "components/productSlider";
import useTenTrendingProducts from "hook/useTenTrendingProducts";

const TrendingProducts = () => {
  const { tenTrendingProducts, loading1 } = useTenTrendingProducts();
  return (
    <ProductSlider
      title="Trending Products"
      viewAllLink="/trendingProducts"
      productsItem={tenTrendingProducts}
      loading={loading1}
    />
  );
};

export default TrendingProducts;
